"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processPnpmWorkspaces = processPnpmWorkspaces;
const debugModule = require("debug");
const fs = require("fs");
const pathUtil = require("path");
const lockFileParser = require("snyk-nodejs-lockfile-parser");
const workspace_utils_1 = require("./workspace-utils");
const debug = debugModule('snyk-pnpm-workspaces');
async function processPnpmWorkspaces(root, settings, targetFiles) {
    const pnpmWorkspaceDirs = (0, workspace_utils_1.sortTargetFiles)(targetFiles, ['pnpm-lock.yaml']);
    debug(`Processing potential Pnpm workspaces (${targetFiles.length})`);
    const result = {
        plugin: {
            name: 'snyk-nodejs-pnpm-workspaces',
            runtime: process.version,
        },
        scannedProjects: [],
    };
    // the folders must be ordered highest first
    for (const directory of Object.keys(pnpmWorkspaceDirs)) {
        debug(`Processing ${directory} as a potential Pnpm workspace`);
        const pnpmWorkspacePath = pathUtil.join(directory, 'pnpm-workspace.yaml');
        if (!fs.existsSync(pnpmWorkspacePath)) {
            debug(`Workspace file not found at ${directory}. Can't be a pnpm workspace root.`);
            continue;
        }
        const scannedProjects = await lockFileParser.parsePnpmWorkspace(root, directory, {
            includeDevDeps: settings.dev || false,
            includeOptionalDeps: settings.optional || true,
            includePeerDeps: true,
            pruneWithinTopLevelDeps: true,
            strictOutOfSync: settings.strictOutOfSync === undefined
                ? true
                : settings.strictOutOfSync,
            exclude: settings.exclude,
            showNpmScope: settings.showNpmScope,
        });
        result.scannedProjects = result.scannedProjects.concat(scannedProjects);
    }
    if (!result.scannedProjects.length) {
        debug(`No pnpm workspaces detected in any of the ${targetFiles.length} target files.`);
    }
    return result;
}
//# sourceMappingURL=pnpm-workspaces-parser.js.map